<template>
    <div class="md_login-panel">
        <div class="wrap">

            <!-- Input -->
            <form class="input-wrap" @submit.prevent="submit">
                <div class="inner">

                    <div class="group _start">

                        <h2><span>Forgot Password</span></h2>
                        <p class="text">AUMAでご利用のメールアドレスをご入力ください。再設定用URLの記載されたメールを送信いたします。</p>
                        <div class="item form_text" v-if="showNotice">{{ noticeMessage }}</div>

                        <!-- Email -->
                        <div class="item form_text">
                            <input id="email-reset" type="email" placeholder=" " v-model="form.email" v-bind:class="{_error: isError}" required autofocus>
                            <label for="email-reset" class="m-label"><span>Email</span></label>
                        </div>

                    </div>

                    <div class="group _end">
                        <div class="btn_link-wrap _w100">
                            <button type="submit" class="btn_link" v-bind:disabled="form.processing"><span>パスワード再設定メールを送信</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div>
            </form>

            <!-- Img -->
            <div class="img-wrap">
                <img src="/img/login-panel.jpg" alt="">
            </div>

        </div>
        <!-- BgText -->
        <div class="bg-text"><span>Password Reset</span></div>
    </div>
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
</template>

<script>
    import { defineComponent } from 'vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import EndUserLayout from '@/Layouts/EndUserLayout'
    import likeMixins from '@/common/like.js'
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'


    export default defineComponent({
        mixins: [likeMixins],
        layout: EndUserLayout,
        components: {
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors,
            "AlertModal": AlertModal,
        },
        props: {
            status: String
        },
        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                }),
                isError: false,
                showAlertModal: false,
                alert_modal_title: "",
                alert_modal_message: "",
                alert_modal_mode: ""
            }
        },
        mounted() {
            this.form.processing = false;
        },
        methods: {
            submit() {
                this.form.post(this.route('password.email'), {
                    preserveScroll: true,
                    onProgress: () => {
                        this.form.processing = true;
                    },
                    onSuccess: () => {
                        this.form.reset();
                        this.isError = false;
                        this.openAlertModal('success', '送信完了', 'パスワード再設定用のメールを送信しました'); // 確認済み
                    },
                    onError: (errors) => {
                        this.form.reset();
                        if (errors.email) {
                            this.isError = true;
                            this.openAlertModal('error', 'エラー', errors.email); // 確認済み
                        }
                    },
                })
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            }
        }
    })
</script>
